import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Blog, BlogEntry } from '../../services/ubs-blog-model';
import { UbsBlogService } from '../../services/ubs-blog.service';
import { UbsBlogStoreService } from '../../services/ubs-blog-store.service';

@Component({
  selector: 'ubs-blog-menu',
  templateUrl: './ubs-blog-menu.component.html',
  styleUrls: ['./ubs-blog-menu.component.scss']
})
export class UbsBlogMenuComponent implements OnInit {
  @Input() blogEntries:BlogEntry[];
  @Input() blogs:Blog[];
  @Input() multiBlog:Boolean;
  vm$ = this.store.vm$;
  blogEntries$ = this.store.blogEntries$;
  altBlogs:Blog[];
  

  constructor(private store:UbsBlogStoreService,private ubsBlogService:UbsBlogService) {}

  ngOnInit(): void {
    /* this.vm$.subscribe((data) => {
      console.log(data);
    }) */
   }

   removeSelectedBlog(){
    this.vm$.subscribe((data) => {
      let selectedBlog = data.blog;
      this.altBlogs = data.blogs.filter(e => e.blogContentId != selectedBlog.blogContentId);
      //console.log(this.altBlogs);
    })
    //filteredAry = ary.filter(e => e !== 'seven')
   }

  selectBlogEntry(e:BlogEntry){
    let contentId = e.contentId;
    let blogContentId = e["ownerContentId"];
    this.ubsBlogService.getBlogEntry(blogContentId,contentId)
    .subscribe(data => {
      this.store.updateSelectedBlogEntry(data);
    })
  }

  selectBlog(blog:Blog){
    /* this.store.updateBlog(blog);
    this.store.loadBlogEntries({"blogContentId":blog.blogContentId});
    this.store.showFirstEntry();
    this.store.blogEntries$.subscribe((data) => {
      let contentId = data[0]["contentId"];
      this.ubsBlogService.getBlogEntry(blog.blogContentId,contentId)
      .subscribe((blogEntry:BlogEntry) => {
        console.log(this.store.loading$.subscribe(data => console.log(data)));
        this.store.updateSelectedBlogEntry(blogEntry);
      })
    }) */
    return '/pages/blog/'+blog.blogContentId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["blogs"]){
      //console.log(this.blogs);
    }
    if(changes["multiBlog"]){
      if(this.multiBlog){
        this.removeSelectedBlog();
      }
     }
  }


}
